<template>
  <merchandise-detail :is-create="true"></merchandise-detail>
</template>

<script>
import MerchandiseDetail from '../components/EditMerchandiseDetail'
export default {
  name: 'CreateMerchandise',
  components: {
    MerchandiseDetail
  }
}
</script>
